import React from "react";
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle, UserAvatar} from "@atttomyx/react-components";
import {datetime} from "@atttomyx/shared-utils";

const NodeCard = (props) => {
    const {node, filters, children} = props;

    return <Card className="node-card" raised={true}>
        <CardContent>
            <CardTitle>
                <UserAvatar user={node} mode="right"/>
            </CardTitle>
            <CardData
                filters={filters}
                data={node}
                keyToMetadata={{
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default NodeCard;
